import DefaultDoubleSkeleton from './default_double_skeleton';

export default DefaultDoubleSkeleton;
